import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Surface',
  setup(__props) {

const SurfaceApp = defineAsyncComponent(() => import('vuecomponents/surface_app.vue'))

return { __sfc: true,SurfaceApp }
}

})